module.exports = __webpack_public_path__ + "img/Speaker=Parth Sareen.18c65092.png";